<template>
  <div class="flex flex-col gap-1">
    <label
      class="text-sm font-medium text-gray-700"
      :for="identifier"
    >
      {{ $t('constants.address.country') }}
    </label>
    <PSelect
      v-if="!is_read_only"
      :id="identifier"
      class="w-full"
      data-test="select-country"
      :disabled="disabled"
      filter
      :auto-filter-focus="true"
      :options="countries_options"
      optionLabel="name"
      optionValue="code"
      :modelValue="country_prop"
      @update:modelValue="handleCountryUpdate"
    />
    <InputText
      v-else
      class="w-full bg-gray-50 text-gray-500"
      :disabled="disabled"
      :modelValue="country_label"
      readonly
    />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import InputText from 'primevue/inputtext';
import COUNTRIES from '@/app/data/countries_constants';

defineOptions({ name: 'SelectCountry' });

const props = defineProps({
  country_prop: { type: String, default: null },
  disabled: { type: Boolean, default: false },
  is_read_only: { type: Boolean, default: false },
  prefix: { type: String, default: '' },
});

const emit = defineEmits(['input', 'change']);

const { t } = useI18n();

const identifier = computed(() => (_.isEmpty(props.prefix) ? 'select-country' : `${props.prefix}-select-country`));

const countries_sorted = computed(() =>
  _.chain(COUNTRIES)
    .reduce((arr, country_code) => {
      arr.push({ code: country_code, name: t(`countries.${country_code}`) });
      return arr;
    }, [])
    .sortBy(['name', 'asc'])
    .value(),
);

const countries_options = computed(() => [{ code: null, name: '-' }, ...countries_sorted.value]);

const country_label = computed(() => (props.country_prop ? t(`countries.${props.country_prop}`) : ''));

const handleCountryUpdate = (value) => {
  const value_next = value ? value.toString() : null;
  emit('input', value_next);
  emit('change');
};
</script>
